module.exports = __webpack_public_path__ + "img/JKiC1e8TxL0AUqOb4kbOn19OvgJfoCJc.f02227f6.png";